export const qualPercent = (vParc: number = 0, vTotal: number = 0) => {
    const value = (100 * vParc) / vTotal;
    return isNaN(value) ? 0 : value
}